import React, { useMemo } from 'react'
import { IcoMoon, VehicleFitIcon, PowersportFitIcon } from '@usap/uicomponents'
import {
  StyledFitmentInfoContainer,
  StyledIconContainer,
  StyledGuaranteedFit,
  StyledFitmentVehicle,
  StyledGuaranteeFitWrapper,
} from '../VehicleFitmentWmo.css'

const GuaranteedFitWmo = ({ vehicle, isPowersport }) => {
  const icon = useMemo(() => {
    if (isPowersport) {
      return PowersportFitIcon
    }
    return VehicleFitIcon
  }, [isPowersport])

  return (
    <StyledGuaranteeFitWrapper data-testid="guaranteed-fit">
      <StyledIconContainer>
        <IcoMoon
          icon={icon}
        />
      </StyledIconContainer>

      <StyledFitmentInfoContainer>
        <StyledGuaranteedFit>
          Guaranteed to Fit &nbsp;
        </StyledGuaranteedFit>
        <StyledFitmentVehicle>
          {vehicle}
        </StyledFitmentVehicle>
      </StyledFitmentInfoContainer>
    </StyledGuaranteeFitWrapper>
  )
}

export default GuaranteedFitWmo
